<template>
    <div
        :class="[{ 'grid_container': (!isModotap() && !isBalancaMode()) || isModotap() }, { 'no-cart-grid': isCartEmpty || isBalancaMode() }, { 'slim-mode': isSlimMode() }, { 'gom-layout': isGomLayout() }]">
        <!-- <Loader v-if="isLoading && false"></Loader> -->
        <template v-if="!isModotap() && !isBalancaMode()">
            <template v-if="isGomLayout()">
                <ModeEntregaGom v-once v-if="showModeEntrega" @hideModoEntrega='hideModoEntrega()'></ModeEntregaGom>
                <Header v-if="!isSlimMode()" v-once class="header"></Header>
                <SideBarGom class="side_bar" :categories="products" @changeCurCat="changeCurCat"
                    :curCategory="curCategory"></SideBarGom>
                <ProductGridGom class="product_grid" :category="products && products[curCategory]"
                    :blockProds="blockProds" :routeSubGroupIndex="subGroupIndex"></ProductGridGom>
                <Transition name="upper-in-out-home">
                    <CartGom class="cart" v-if="cartVisible" @minimizeCart="toggleCartVisibility()"></CartGom>
                </Transition>
            </template>
            <template v-else>
                <ModeEntrega v-once v-if="showModeEntrega" @hideModoEntrega='hideModoEntrega()'></ModeEntrega>
                <Header v-if="!isSlimMode()" v-once class="header"></Header>
                <SideBar class="side_bar" :categories="products" @changeCurCat="changeCurCat"
                    :curCategory="curCategory"></SideBar>
                <ProductGrid class="product_grid" :category="products && products[curCategory]" :blockProds="blockProds"
                    :routeSubGroupIndex="subGroupIndex"></ProductGrid>
                <Transition name="upper-in-out-home">
                    <Cart v-if="cartVisible" class="cart" @minimizeCart="toggleCartVisibility()"></Cart>
                </Transition>
            </template>
            <EditMode v-if="editMode" @closeEditMode="closeEditMode"></EditMode>
        </template>
        <template v-else-if="isModotap()">
            <TAPScreen></TAPScreen>
        </template>
        <div class="overlay" v-if="(!isModotap() && showModeEntrega && !isBalancaMode())"></div>
    </div>
</template>

<script>
import eventModule from '@/assets/libs/eventModule'
import Loader from '@/components/Loader'
import ModeEntrega from '@/components/ModeEntrega'
import ModeEntregaGom from '@/components/ModeEntregaGom'
import Header from '@/components/Header'
import SideBar from '@/components/SideBar'
import SideBarGom from '@/components/SideBarGom'
import ProductGrid from '@/components/ProductGrid'
import ProductGridGom from '@/components/ProductGridGom'
import TAPScreen from '@/pages/TAPScreen'
import Cart from '@/components/Cart'
import CartGom from '@/components/CartGom'

import productController from '@/assets/controllers/ProductController'
import CartController from '@/assets/controllers/CartController'
import Util from '@/assets/libs/util'
import EditMode from '../components/EditMode.vue'
import ShowCart from '../components/ShowCart.vue'
import LocaleController from '@/assets/controllers/LocaleController'
import ClarityController from '@/assets/controllers/ClarityController'

export default {
    name: 'Home',
    components: {
        Loader,
        Header,
        SideBar,
        SideBarGom,
        ProductGrid,
        ProductGridGom,
        Cart,
        CartGom,
        ModeEntrega,
        ModeEntregaGom,
        TAPScreen,
        EditMode,
        ShowCart
    },
    data () {
        return {
            products: [],
            isLoading: null,
            isCartEmpty: CartController.getCart().length === 0,
            curCategory: 0,
            showModeEntrega: false,
            subGroupIndex: null,
            blockProds: [],
            hourlyUnavailableProds: [],
            editMode: false,
            cartVisible: false,
            showButtonCart: false,
            hybridMode: false
        }
    },
    methods: {
        isModotap: function () {
            return Util.isTapMode()
        },
        isEditMode: function () {
            return Util.isEditMode()
        },
        isBalancaMode: function () {
            return false // Util.isBalancaMode()
        },
        isSlimMode: function () {
            return Util.isSlimMode()
        },
        isGomLayout: function () {
            return Util.getLocalConfigs('utiliza_layout_gom')
        },
        carItemAdd: function () {
            this.isCartEmpty = false
        },
        // isCartEmpty: function () {
        //     return CartController.getCart().length === 0
        // },
        toggleCartVisibility: function () {
            this.cartVisible = !this.cartVisible
        },
        closeEditMode: function () {
            this.editMode = false
            this.$forceUpdate()
        },
        getProducts: async function () {
            this.isLoading = true
            this.products = await productController.getProducts()
            // console.log('products', this.products)
            this.blockProds = await productController.getBlockProducts()
            this.hourlyUnavailableProds = await productController.getProdAvailabilityPerHour()
            Util.setLocalVar('blockProds', this.blockProds)
            Util.setLocalVar('hourlyUnavailableProds', this.hourlyUnavailableProds)
            this.isLoading = false
            if (this.$route.params.catGroupName) {
                this.curCategory = this.products.indexOf(this.products.find(c => c.groupName === this.$route.params.catGroupName))
                this.subGroupIndex = this.$route.params.subGroupIndex
                this.scrollToCurCat()
            }
        },
        changeCurCat: function (cat) {
            if (cat == null || !this.products[cat] || !this.products[cat].groupName) {
                return
            }
            if (this.curCategory === cat) {
                return
            }
            ClarityController.event('usuario_visualizou_categoria')
            ClarityController.setTag('categoria_visualizada', this.products[cat].groupName)
            this.subGroupIndex = null
            eventModule.$emit('closeProductItem')
            this.curCategory = cat
            window.scrollTo(0, 0)
        },
        scrollToCurCat: function () {
            setTimeout(() => {
                if (document.getElementsByClassName('categorie active') && document.getElementsByClassName('categorie active')[0]) {
                    document.getElementsByClassName('categorie active')[0].scrollIntoViewIfNeeded({ behavior: 'smooth' })
                }
            }, 300)
        },
        hideModoEntrega: function () {
            this.showModeEntrega = false
        },
        updateButtonCart: function (status, insertedBarCode) {
            this.showButtonCart = status
            this.cartVisible = status
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        handleNavigateToGroup: function (groupName) {
            const index = this.products.indexOf(this.products.find(c => c.groupName === groupName))
            if (index !== -1) {
                this.changeCurCat(index)
            }
        },
        navigateToGroup: function (groupName) {
            this.closeSuggestionsMenuModal()
            eventModule.$emit('navigateToGroup', groupName)
        }
    },
    mounted () {
        let config = Util.getLocalVar('taaconfig')
        let modeEntrega = config && config['modeEntrega']
        this.editMode = this.isEditMode()
        this.showModeEntrega = this.$route && this.$route.params && this.$route.params.showModeEntrega === true && (modeEntrega && modeEntrega.length > 1)
        this.hybridMode = this.$route && this.$route.params && this.$route.params.hybridMode === true
        if (!this.isModotap()) {
            this.getProducts()
            this.scrollToCurCat()
        }
        if (this.$route && this.$route.params && this.$route.params.openCart) {
            setTimeout(() => {
                eventModule.$emit('openCart', true)
            }, 1000)
        }

        if (this.$route && this.$route.params && this.$route.params.product) {
            eventModule.$emit('closeProductItem')
            setTimeout(() => {
                eventModule.$emit('openProductItem', { product: this.$route.params.product, key: this.$route.params.key })
            }, 800)
        }
        this.updateButtonCart(true)
    },
    created () {
        eventModule.$on('navigateToGroup', this.handleNavigateToGroup)
        eventModule.$on('barCodeProductAdd', this.carItemAdd)
        eventModule.$on('updateButtonCart', this.updateButtonCart)
    },
    beforeDestroy () {
        eventModule.$off('barCodeProductAdd', this.carItemAdd)
        eventModule.$off('updateButtonCart', this.updateButtonCart)
        eventModule.$off('navigateToGroup', this.handleNavigateToGroup)
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.grid_container {
    display: grid;
    grid-template: "header header header header"
        "side grid grid grid"
        "cart cart cart cart";
    // "poweredby poweredby poweredby poweredby";
    grid-template-rows: auto 6fr auto;
    grid-template-columns: 1fr 1fr auto 1fr;
    height: calc(100vh - 60px);

    &.slim-mode {
        // grid-template-rows: 0 6fr 1fr;
    }

    &.no-cart-grid {
        grid-template-rows: auto 6fr auto;
    }

    &.gom-layout {
        grid-template-columns: 1.1fr 1.3fr auto 1fr;
    }
}

.header {
    grid-area: header;
    z-index: 1;
}

.side_bar {
    /* background: rgb(231, 227, 227);
        grid-area: side;
        filter: drop-shadow(0px 0px 5px  rgba(0, 0, 0, .5));
        max-height: 100%;
        position: relative;
        display: block;
        overflow: hidden scroll; */

    background: #e7e3e3;
    grid-area: side;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.5);
    /* Alternativa ao drop-shadow */
    max-height: 100%;
    position: relative;
    display: block;
    overflow: auto;
    /* Evita problemas com hidden scroll */
    overflow-x: hidden;
}

.product_grid {
    grid-area: grid;
    position: relative;
    background-color: white;
    width: 100%;
    height: 100%;
    overflow: hidden scroll;
    // padding-bottom: 100px;
}

.cart {
    z-index: 1;
    grid-area: cart;
    background-color: rgb(226, 225, 225);
}

.poweredby {
    grid-area: poweredby;
}

.overlay {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.8);
    z-index: 2;
}
@media (min-width: 699px) and (max-width: 900px) {
    .grid_container {
        grid-template-columns: 220px 1fr auto 1fr;
        &.gom-layout {
            grid-template-columns: 1.1fr 1.2fr auto 1fr;
        }
    }
}
@media (min-width: 901px) and (max-width: 1025px) {

    .grid_container {
        grid-template-columns: 250px 1fr auto 1fr;
        &.gom-layout {
            grid-template-columns: 1.1fr 1.2fr auto 1fr;
        }
    }

}

@media (max-width: 698px) {

    // Gertec SK210
    .grid_container {
        grid-template-columns: 1fr 1.2fr auto 1fr;
        height: calc(100vh - 30px);

        &.gom-layout {
            grid-template-rows: auto 3fr auto;
        }
    }
}

.upper-in-out-home-enter-active {
    position: absolute;
    width: 100vw;
    bottom: 0;
    animation: upper-in-out 0.4s;
}

.upper-in-out-home-leave-active {
    position: absolute;
    width: 100vw;
    bottom: 0;
    animation: upper-in-out 0.4s reverse;
}

@keyframes upper-in-out {
    0% {
        transform: translateY(180px);
    }

    100% {
        transform: translateY(0);
    }
}

@media (orientation: landscape) {
    .grid_container {
        grid-template-rows: auto 6fr auto;
        grid-template-columns: 250px 2fr auto 2fr;
        height: calc(100vh - 30px);

        &.no-cart-grid {
            grid-template-rows: auto 6fr auto;
        }

        &.gom-layout {
            grid-template-columns: 1fr 4fr;
            grid-template-rows: auto 6fr auto;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue